export const steps = [
  {
    target: '#ResourceBoard',
    title: 'Resource Board',
    content:
      'This is the Resource Board. Tap or click on a resource to adjust it.',
    placement: 'center',
  },
  {
    target: '#CreditContainer',
    title: 'Resource Tracker',
    content: 'Each resource has a production area and current amount area.',
    placement: 'bottom-end',
  },
  {
    target: '#ControlBar',
    title: 'Adjustment Controls',
    content: 'Use these controls to adjust the highlighted resource.',
    placement: 'bottom-end',
  },
  {
    target: '#CreditTotal',
    title: 'Amount/Total Area',
    content:
      'The amount area shows the current amount of the resource. Highlights green when selected. Tap to adjust.',
    placement: 'bottom-end',
  },
  {
    target: '#CreditProduction',
    title: 'Production Area',
    content:
      'The amount area shows the production rate of the resource. Highlights green when selected. Tap to adjust.',
    placement: 'bottom-end',
  },
  {
    target: '#TerraformRating',
    title: 'Terraform Rating',
    content:
      'Track your Terraform Rating here. This is used to calculate your credit production rate.',
    placement: 'bottom-start',
  },
  {
    target: '#ResourcePhaseButton',
    title: 'Resource Phase',
    content:
      'Automatically execute the resource phase based on your Terraform Rating and production rates.',
    placement: 'bottom-start',
  },
  {
    target: '#CartButtonBar',
    title: 'Purchase Tool',
    content:
      'Use this tool to purchase cards using Mega Credits, Steel and Titanium',
    placement: 'right',
  },
  {
    target: '#PurchaseResourceArea',
    title: 'Purchase Payment',
    content:
      'Use this area to adjust your payment for the card you want to buy.',
    placement: 'right',
  },
  {
    target: '#FinalizePurchaseButton',
    title: 'Deduct Resources',
    content: 'Click to deduct the selected Resources from you game board.',
    placement: 'right',
  },
  {
    target: '#GameControl',
    title: 'Undo Redo Controls',
    content: 'Just in case you make a mistake.',
    placement: 'top-start',
  },
];
